import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

/**
 * @typedef {Object} CollectionHeroRefs
 * @property {HTMLElement} [tiles]
 * @property {HTMLElement} [footer]
 */

/**
 * On mobile, after navigating here from a tile click on another collection
 * page, auto-scroll past the "Shop by" tiles so the shopper lands on the
 * product grid instead of a screen full of tiles they already picked from.
 * Only triggers on same-origin (in-site) navigation, never on a fresh/direct
 * load, and is skipped entirely under prefers-reduced-motion.
 *
 * @extends {Component<CollectionHeroRefs>}
 */
export class CollectionHeroComponent extends Component {
  requiredRefs = [];

  connectedCallback() {
    super.connectedCallback();

    const target = this.refs.footer || this.refs.tiles;
    if (!target) return;

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (!isMobile) return;

    let cameFromSiteNavigation = false;
    try {
      cameFromSiteNavigation = document.referrer !== '' && new URL(document.referrer).origin === window.location.origin;
    } catch {
      cameFromSiteNavigation = false;
    }
    if (!cameFromSiteNavigation) return;

    requestAnimationFrame(() => {
      target.scrollIntoView({
        behavior: prefersReducedMotion() ? 'instant' : 'smooth',
        block: 'start',
      });
    });
  }
}

if (!customElements.get('collection-hero-component')) {
  customElements.define('collection-hero-component', CollectionHeroComponent);
}
